import { format } from 'date-fns'

export const formatDateFromIso = (date: string, dateFormat: string) =>
  format(Date.parse(date), dateFormat)

export const getDay = (date: string) => new Date(date).getDate()

export const getMonth = (date: string) => new Date(date).getMonth()

export const getYear = (date: string) => new Date(date).getFullYear()

export const formatTime = (time?: string) => {
  if (time) {
    const [hours, minutes] = time.split(':')
    return `${hours}:${minutes}`
  }
  return ''
}

export const getUtcDate = (date: string) => {
  const [day, month, year] = date.split('.').map(Number)
  return new Date(Date.UTC(year, month - 1, day, 0, 0, 0))
}
